/*
 * @Author: liyxt
 * @Date: 2020-05-06 14:00:41
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 15:02:29
 * @Description: file content
 */ 
import React, { Component } from 'react';
import ReactToPrint from 'react-to-print';

export default class Print extends Component {
	render() {
		return <ReactToPrint {...this.props} />;
	}
}
